/* PDP Cart + Wishlist Side-by-Side Layout (Modern-Pattern)

   Verschiebt den HulkApps-Wishlist-Block in den Cart-Button-Container,
   sodass beide nebeneinander auf einer Zeile rendern (Cart-Button breit,
   Wishlist als kleiner Icon-Button rechts).

   Re-runs bei `shopify:section:load`, damit Theme-Editor-Reloads das
   Layout nicht zerschiessen. Idempotent.
*/
(function () {
  function relocateWishlist(scope) {
    const root = scope || document;
    const productForms = root.querySelectorAll('product-form');
    productForms.forEach((form) => {
      const buttonsContainer = form.querySelector('.product-form__buttons');
      if (!buttonsContainer) return;

      // Wishlist-Block liegt in der gleichen <section.product__info-container>.
      const productInfo = form.closest('.product__info-container');
      if (!productInfo) return;

      const wishlistBlock = productInfo.querySelector(
        '[id*="advanced_wishlist_wishlist_btn"]'
      );
      if (!wishlistBlock) return;

      // Schon umsortiert? Dann nichts tun.
      if (buttonsContainer.contains(wishlistBlock)) {
        buttonsContainer.classList.add('has-cart-wishlist-row');
        return;
      }

      buttonsContainer.appendChild(wishlistBlock);
      wishlistBlock.classList.add('cart-row-wishlist');
      buttonsContainer.classList.add('has-cart-wishlist-row');
      lockHulkInnerStyles(wishlistBlock);
    });
  }

  // HulkApps' CSS hat ID-Selektor + !important Regeln auf :hover, die
  // .hulk_wl_icon-text + .count border 0->1px setzen — das schiebt den
  // Wishlist-Btn um +2px Hoehe, was via flex-stretch auch den Cart-Btn
  // mitwachsen laesst. Inline-style mit !important schlaegt jede
  // CSS-Regel (egal welche Spezifizitaet) und bleibt stabil bei Hover.
  function lockHulkInnerStyles(scope) {
    const targets = scope.querySelectorAll('.hulk_wl_icon-text, .count, .hulkapps-public-count');
    targets.forEach((el) => {
      el.style.setProperty('border', 'none', 'important');
      el.style.setProperty('border-radius', '0', 'important');
      el.style.setProperty('background', 'transparent', 'important');
      el.style.setProperty('background-color', 'transparent', 'important');
    });

    // HulkApps setzt margin: 5px 0 !important via ID-Selektor (Spezifizitaet
    // 1,2,0). Inline-style scheitert hier weil Hulk eigenes JS `style.cssText`
    // ueberschreibt (zerstoert vorher gesetztes inline). Stattdessen injizieren
    // wir ein <style>-Tag mit Hulk's exakter ID + zusaetzlichen Klassen, damit
    // unsere Spezifizitaet (1,3,0) Hulk's Regel schlaegt.
    injectHulkOverrideRules(scope);
  }

  function injectHulkOverrideRules(scope) {
    const hulkId = scope.id;
    if (!hulkId || document.getElementById('pdp-hulk-margin-override')) return;
    const style = document.createElement('style');
    style.id = 'pdp-hulk-margin-override';
    style.textContent =
      '#' + CSS.escape(hulkId) + ' .wishlist-btn.hulkapps-wishlist-btn-enabled.heart-wishlist-animation,' +
      '#' + CSS.escape(hulkId) + ' .wishlist-btn.style_4.hulkapps-wishlist-btn-enabled,' +
      '#' + CSS.escape(hulkId) + ' .wishlist-btn.style_2.hulkapps-wishlist-btn-enabled' +
      ' { margin: 0 !important; }';
    document.head.appendChild(style);
  }

  // Initial-Run (DOM ready oder schon parsed).
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => relocateWishlist());
  } else {
    relocateWishlist();
  }

  // Theme-Editor: Section-Reload triggert section:load — Wishlist-Block
  // wird neu gerendert, also wieder umsortieren.
  document.addEventListener('shopify:section:load', (event) => {
    relocateWishlist(event.target);
  });

  // HulkApps koennte den Block nach Pageload nachladen — re-checken nach
  // kurzer Verzoegerung, falls er beim ersten Run noch nicht im DOM war.
  setTimeout(() => relocateWishlist(), 800);
})();
